(function(){

    angular.module('tmx-app').controller('processDesignerCtrl', ['ProcessDesignerService','menu','tmxUtility', '$state','tmxResource', 

        function ProcessDesignerCtrl(ProcessDesignerService,menu,tmxUtility, $state,tmxResource){


            var workflowdesignerVM=this;
            var exists = tmxUtility.exists;
            var copy = tmxUtility.copy;

            workflowdesignerVM.checkPermission = tmxUtility.checkPermission;
            workflowdesignerVM.menu=menu;


            workflowdesignerVM.editPermission=workflowdesignerVM.checkPermission("Private.Controls.ProcessDesigner","Edit");

            workflowdesignerVM.locate = function () {
        // $window.location.href = '\process-designer\edit\edit.html';
        //$state.data.info = false;
                $state.go($state.current.name + ".edit");
            }

            workflowdesignerVM.onChildState = function() {
                if ($state.current.name.indexOf(".add") > 0 || $state.current.name.indexOf(".edit") > 0) return true;
            };
    
    // workflowdesignerVM.loanproducts=[];
    // tmxResource("LoanApplication").getByAction('Workflow',true,'get').then(function(response) {
    //     workflowdesignerVM.loanproducts = response.data;
    //  });

            workflowdesignerVM.new = function() {
        //userVM.searchClear = true;
                $state.data.info = false;
                $state.go($state.current.name + ".add");
            };

///////////////// grid
            workflowdesignerVM.ProcessDesignerService = ProcessDesignerService;
            workflowdesignerVM.cols = ProcessDesignerService.gridColumn;
            workflowdesignerVM.schema = ProcessDesignerService.schema;
            workflowdesignerVM.gridData = new kendo.data.ObservableArray([]);
            workflowdesignerVM.cloneColumn = angular.copy(ProcessDesignerService.gridColumn);
            workflowdesignerVM.clone = 0;
    // workflowdesignerVM.EditPrivilege = false;
            workflowdesignerVM.dataObj = {
                value: "empty"
            };

            workflowdesignerVM.isEditable=function(dataitem){
                if(dataitem.Status=="Active" || dataitem.Status=="Pending" ){
                    return true;
                }
                return false;
            }

            workflowdesignerVM.formatPhoneNumber=function(dataitem){
                if(angular.isDefined(dataitem.PhoneNumber) && dataitem.PhoneNumber!=null) {
                    return "+"+dataitem.PhoneNumber;
                }
                return "N/A";
            }

            workflowdesignerVM.formatUserName = function(item) {
        //if(item.UserName.length>10)
        //{
        //  return item.UserName.slice(0,10)+"...";
        //}
       // return  tmxUtility.sliceText(item.UserName,25);
                return item.WorkflowSchemeCode;
  
            };

            workflowdesignerVM.getDesignation = function(dataitem) {
        
                if (angular.isDefined(dataitem.Designation) && dataitem.Designation!=null && dataitem.Designation!="") {
                    if(angular.isDefined(ProcessDesignerService.desigs) && ProcessDesignerService.desigs.length>0) {
                        for (var i = ProcessDesignerService.desigs.length - 1; i >= 0; i--) {
                            if (ProcessDesignerService.desigs[i].HiddenValue == dataitem.Designation) {
                                return ProcessDesignerService.desigs[i].VisibleValue;
                            }
                        }
                    }
                }
                return "N/A";
            };

            workflowdesignerVM.getStatus = function(dataitem) {


                if (dataitem.Status=="Active") {
                    return "Active";
                }
                else if(dataitem.Status=="Pending"){
                    return "Pending";
                }
                else{
                    return "Inactive";
                }
            };

            workflowdesignerVM.getUserType = function(dataitem) {
       
                if (angular.isDefined(ProcessDesignerService.type) && ProcessDesignerService.type.length > 0) {
                    for (var i = ProcessDesignerService.type.length - 1; i >= 0; i--) {
                        if (ProcessDesignerService.type[i].LookupId == dataitem.UserTypeLkp) {
                            return ProcessDesignerService.type[i].VisibleValue;
                        }
                    }
                }
                return "N/A";
            };

            workflowdesignerVM.isFiltered=function(){
                return true;
            };
    
            workflowdesignerVM.clickEdit = function(item) {
                $state.data.info = false;

                $state.go($state.current.name + ".edit", {
                    "Id": item.value
                });
            };
            workflowdesignerVM.gridColumns = angular.copy(ProcessDesignerService.columns);
            workflowdesignerVM.mainGridOptions = {
                dataSource: {
                    transport: {
                        read: function(o) {
                            if(angular.isDefined(workflowdesignerVM.searchClear) && workflowdesignerVM.searchClear==false){
                                if(exists(workflowdesignerVM.o)){
                                    copy(workflowdesignerVM.o.data,["filter"],o.data);
                                }
                            }
                            workflowdesignerVM.searchClear = false;
                            if(workflowdesignerVM.onChildState()){return;}
                            if(!o.fromSideNav) {
                                if($state.searchClear){
                                    workflowdesignerVM.searchClear = true;
                                    $state.searchClear=undefined;
                                }
                            }
                            else
                                o.data.firstPage = true;
                            workflowdesignerVM.o = angular.copy(o);
                            if(workflowdesignerVM.o.data.firstPage){
                                selected();
                            }
                            workflowdesignerVM.filters = workflowdesignerVM.o.data.filter;

              // Dont Return Rows With Empty Scheme Code.
                            workflowdesignerVM.filt = {
                                filters: [{
                                    field: "WorkflowSchemeCode",
                                    operator: "neq",
                                    value: ""
                                }]
                            };
                            o.data.filter = workflowdesignerVM.filt;

                            tmxResource("LoanApplication/Workflow").getByParams(o, true).then(function(response) {
                                o.success(response);

                    
                            });
                        },
                        dataType: "json"
                    },
                    schema: {
                        data: "data",
                        total: "Total"
                    },
        
                    group: {
                        field: "WorkflowSchemeCode"
                    },
                    serverPaging: true,
                    serverFiltering: true,
                    serverSorting: true,

                    sort:  [{field: "ProductCode", dir: "asc"}],
                },
                pageable: {
                    refresh: true,
                    pageSizes: true,
                    pageSize: 10,
                    buttonCount: 5
                },
                pdf: {
                    allPages: true,
                    fileName: "ProcessDesigner.pdf"
                },
                excel: {

                    fileName: "ProcessDesigner.xlsx"
                },
                sortable: true,
                scrollable: false,
                columns: workflowdesignerVM.gridColumns
            };

   //////////////////////////////////////////////
            workflowdesignerVM.bulk = [];
            workflowdesignerVM.container = {};
            $state.data = {
                grid: workflowdesignerVM.container
            };
            workflowdesignerVM.searchSideNavActive = false;
            workflowdesignerVM.exportSideNavActive = false;
            workflowdesignerVM.filt = {};
//////////////////////////////////////////////////
            function selected() {
                var dataSource =  workflowdesignerVM.container.userGrid.dataSource;
                if(angular.isDefined(workflowdesignerVM.o) && angular.isDefined(dataSource) &&
        workflowdesignerVM.o.data.firstPage && dataSource.page() != 1) {//implies data loaded into grid is just the firt page data
                    dataSource.page(1);
                }
            }
  

        }]);


})();


